import { useLanguage, useSEO } from "../context/LanguageContext";
import { PageHero, SectionHeading, Reveal, Overline } from "../components/Kinetic";
import { SubmissionForm } from "../components/SubmissionForm";
import { ArrowUpRight } from "lucide-react";

const PartenariatsPage = () => {
  const { t } = useLanguage();
  useSEO(t("partenariats.metaTitle"), t("partenariats.metaDesc"));
  const targets = t("partenariats.targets");

  const fields = [
    { name: "name", label: t("forms.name"), type: "text" },
    { name: "email", label: t("forms.email"), type: "email" },
    { name: "organization", label: t("forms.organization"), type: "text" },
    { name: "orgType", label: t("forms.orgType"), type: "select", options: t("forms.orgTypeOptions") },
    { name: "message", label: t("forms.message"), type: "textarea" },
  ];

  return (
    <div data-testid="partenariats-page">
      <PageHero
        overline={t("partenariats.overline")}
        titleLines={t("partenariats.titleLines")}
        intro={t("partenariats.intro")}
        testid="partenariats"
      />

      <section className="py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-6">
          <SectionHeading overline={t("partenariats.targetsOverline")} title={t("partenariats.targetsTitle")} />
          <div className="mt-14 grid gap-px bg-graphite/10 sm:grid-cols-2 lg:grid-cols-4" data-testid="partenariats-targets">
            {targets.map((target, i) => (
              <Reveal key={target} delay={i * 0.04} className="group flex items-center justify-between bg-bone p-6 transition-colors duration-300 hover:bg-science">
                <span className="font-display text-lg font-light tracking-tight text-graphite transition-colors duration-300 group-hover:text-white">
                  {target}
                </span>
                <ArrowUpRight className="h-4 w-4 text-graphite/25 transition-all duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-white" />
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <div className="mt-16 max-w-3xl border-l-2 border-science pl-6">
              <p className="overline-mono text-science">{t("partenariats.honestyTitle")}</p>
              <p className="mt-3 text-base leading-relaxed text-graphite-soft">{t("partenariats.honestyText")}</p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="border-t border-graphite/10 bg-white py-24 md:py-32">
        <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <Reveal y={16}>
              <Overline>{t("nav.partenariats")}</Overline>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 font-display text-3xl md:text-5xl font-light tracking-tight text-graphite">
                {t("partenariats.formTitle")}
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 max-w-md text-base leading-relaxed text-graphite-soft">{t("partenariats.formText")}</p>
            </Reveal>
          </div>
          <Reveal delay={0.15} className="lg:col-span-3">
            <SubmissionForm formType="partner" fields={fields} submitLabel={t("partenariats.formSubmit")} testid="partner" />
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default PartenariatsPage;
